export interface IRCPPRespGeneralData {
  data: IRCCPGeneralData | string;
  successful: boolean;
  message: string;
}

export interface IRCCPGeneralData {
  puntos: IPuntos;
  compra: ICompra;
  reto: IReto;
  autoevaluacion: IAutoevaluacion;
  portafolio: ICustomPortfolio;
  fechaActualizacion: string;
  cliente: ICliente;
  metadata: IMetadata;
}

export interface IAutoevaluacion {
  idPilar?: number;
  numPuertas: number;
  puntosPosibles: number;
  puntosObtenidos?: number;
  estatus: number;
  fechaInicio: string | null;
  fechaFin: string | null;
}

export interface ICliente {
  claveBodega: string;
  nud: string;
}

export interface ICompra {
  idPilar?: number;
  puntosMes: number;
  puntosUltima: number;
  fechaMes?: string;
}

export interface ICustomPortfolio {
  idPilar: number;
  nombre: string;
  estatus: number;
  fechaInicio: string;
  fechaFin: string;
  fechaProximoInicio: string;
  fechaActualizacion: string;
  puntosPremio: number;
  puntosObtenidos: number;
  skuLiquidados: number;
  skuObjetivos: number;
}

export interface IMetadata {
  fechaActualizacion: string;
}

export interface IPuntos {
  disponibles: number;
  totalGanadosHistorico: number;
  totalCanjeadosHistorico: number;
  cajasGanadas: number;
  costoCanje: number;
}

const DEFAULT_PUNTOS: IPuntos = {
  disponibles: 0,
  totalGanadosHistorico: 0,
  totalCanjeadosHistorico: 0,
  cajasGanadas: 0,
  costoCanje: 0
};

export const DEFAULT_DATA: IRCCPGeneralData = {
  puntos: DEFAULT_PUNTOS
} as IRCCPGeneralData;

export interface IReto {
  idPilar?: number;
  id: string;
  nombre: string;
  fechaInicio: string;
  fechaFin: string;
  puntosPremio: number;
  objetivo: number;
  avance: number;
  porcentajeObjetivo: number;
  porcentajeAvance: number;
  estatus: number;
  puntosObtenidos: number;
  fechaActualizacion: string;
  montoRestante: number;
}

export interface IRCPPRespMovement {
  data: IRCCPMovement | string;
  successful: boolean;
  message: string;
}

export interface IRCCPMovement {
  cliente: ICliente;
  movimientos: IMovimiento[];
  metadata: IMetadata;
}

export const DEFAULT_MOVEMENT: IRCCPMovement = {
  cliente: null,
  movimientos: [],
  metadata: null,
} as IRCCPMovement;

export interface IMovimiento {
  id: string;
  timestamp: number;
  fechaEvento: string;
  descripcion: string;
  detalle?: string;
  puntos: number;
  esAbono: number;
  tipoMovimiento: string;
  balanceAnterior: number;
  balanceResultante: number;
}

export interface IRCCPGeneralDataByIdResp {
  data: IRCCPGeneralDataById | string | null;
  successful: boolean;
  message: string;
}

export type TPilar = IPuntos | ICompra | IReto | IAutoevaluacion | ICustomPortfolio;

export type IRCCPGeneralDataById =
  Partial<Omit<IRCCPGeneralData, 'cliente' | 'metadata'>> &
  Pick<IRCCPGeneralData, 'cliente' | 'metadata'>;

export interface FavsControlDias extends ICustomPortfolio {
  diasDiferenciaVigencia?: string;
  diasDiferenciaProximo?: string;
}

export const TIME_TO_CHANGE_SLIDE = 5000; // Tiempo de cambio de info, en milisegundos
export const ESTATUS_NO_APLICA = 0; // No se ve card
export const ESTATUS_PROXIMAMENTE = 1; // No se ve card
export const ESTATUS_EN_PROGRESO = 2; // Barra de progreso
export const ESTATUS_COMPLETADO = 3; // Card completado con swiper
export const ESTATUS_EXPIRADO = 4; // Card de no logrado
export const ESTATUS_ERROR = NaN; // Card de "Espera! Cargando..."

export const DEFAULT_FAVS_CONTROL: FavsControlDias = {
  idPilar: 4,
  nombre: '',
  estatus: ESTATUS_NO_APLICA,
  fechaInicio: '',
  fechaFin: '',
  fechaProximoInicio: '',
  fechaActualizacion: '',
  puntosPremio: 0,
  puntosObtenidos: 0,
  skuLiquidados: 0,
  skuObjetivos: 0,
  diasDiferenciaVigencia: '',
  diasDiferenciaProximo: '',
};

export const DEFAULT_GENERAL_DATA_BY_ID: IRCCPGeneralDataById = {
  autoevaluacion: { idPilar: 1 } as IAutoevaluacion,
  compra: { idPilar: 2 } as ICompra,
  reto: { idPilar: 3 } as IReto,
  portafolio: { idPilar: 4, estatus: ESTATUS_NO_APLICA } as ICustomPortfolio,
  puntos: DEFAULT_PUNTOS,
  cliente: {} as ICliente,
  metadata: {} as IMetadata,
};

export const MAPA_PILAR: Record<number, keyof IRCCPGeneralDataById> = {
  1: 'autoevaluacion',
  2: 'compra',
  3: 'reto',
  4: 'portafolio',
};
